import { service, model } from 'eco-cli'
import { Adapter } from '@/models/Adapter.js'
import {
  Worksheet, WorksheetDetail, Comment
} from '@/models/Worksheet'

const { worksheet } = service;
const { Filter, Page, Sort, UserInfo } = model;

// 身份认证
export const verfiyCompany = (params) =>
worksheet.withToken
    .put("/worksheet/workOrder/authCompanyUser", { productCompanyName: params.worksheetCompanyName, productContact: params.worksheetContacter, productEmail: params.worksheetEmail })

// 判断用户是否提过工单
export const hasWorksheet = () => worksheet.withToken.get("/worksheet/workOrder/user/hasOrder")

// 获取工单列表
export const getWorksheetList = ({
  filter = Filter.new(), sort = Sort.new(), page = Page.new()
}) => worksheet.withToken.post('/worksheet/workOrder/query/myWorkOrder', {
  ...filter.toServer(),
  ...sort.toServer(),
  ...page.toServer()
}).then(data => {
  return {
    list: data.records.map(v => Worksheet.fromServer(v)),
    page: Page.fromServer(data)
  }
})

// 新增工单
export const addWorksheet = (param) => worksheet.withToken.post('/worksheet/workOrder/addOrUpdate/workOrder', param.toServer())

// 获取工单详情
export const getWorksheetDetail = (id) => worksheet.withToken.get('/worksheet/workOrder/getWorkOrder/' + id ).then((res)=>{
  return {
    data: WorksheetDetail.fromServer(res),
    commentList: res.commentModelList.map(v=>Comment.fromServer(v)),
    assessResult: res.evaluateModel ? res.evaluateModel:null,
    questionAnswer: res.questionAnswer ? res.questionAnswer : null
  }
})

// 上传图片
export const postImage = (formdata) => worksheet.withToken.post('/worksheet/attach/uploadImage', formdata)

// 撤销工单
export const revokeWorksheet = (id) => worksheet.withToken.get('/worksheet/workOrder/cancel/order/' + id)

// 回复工单
export const replyWorksheet = (params) => worksheet.withToken.post('/worksheet/comment/addOrderComment', params.toServer())

// 工单评价
export const assessWorksheet = (params) => worksheet.withToken.post('/worksheet/workOrder/addWorkOrderEvaluate', params)